import React from "react";
import Button from "@material-ui/core/Button";
import TextTheme from "components/General/Text/TextTheme";
import "../../Appearance.css";

const RoundedButton = (props) => {
  return (
    <Button
      size="small"
      variant="outlined"
      component="span"
      id={props.id}
      startIcon={props.startIcon}
      endIcon = {props.endIcon}
      className={props.buttonClassName}
      style={{
        textTransform: "None",
        borderRadius: props.borderRadius || "10px 10px 10px 10px",
        margin: props.margin || "0px",
        border: props.border || "0px solid",
        width: props.width || "",
      }}
      disabled={props.disabled}
      hidden={props.hidden}
      onClick={props.handleOnClick}
    >
      <TextTheme message={props.title} className={props.textThemeClassName} />
    </Button>
  );
};

export default RoundedButton;
